// extracted by mini-css-extract-plugin
var _1 = "IntegrationCardContent-module__animateUploadProgressBarWidth--dq9HV";
var _2 = "IntegrationCardContent-module__animatedBackground--p4hy2";
var _3 = "IntegrationCardContent-module__content--iSSBB";
var _4 = "IntegrationCardContent-module__hoverTarget--exWZO";
var _5 = "IntegrationCardContent-module__iconContainer--XcJjN";
var _6 = "IntegrationCardContent-module__slackIcon--vXxOp";
var _7 = "IntegrationCardContent-module__tag--oqiUX";
var _8 = "IntegrationCardContent-module__tags--DdU1A";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "content", _4 as "hoverTarget", _5 as "iconContainer", _6 as "slackIcon", _7 as "tag", _8 as "tags" }
